import { DataRow } from "pages/meter/components";
import { IDataRow } from "pages/meter/types";

type IListProps = {
  dataList: IDataRow[];
  onToDetailPage: (data: IDataRow) => void;
};

export const List = ({ dataList, onToDetailPage }: IListProps) => {
  return (
    <div className="px-[10px] pb-3">
      {dataList.map((item) => (
        <div key={item.id} className="mt-4">
          <DataRow data={item} onClick={() => onToDetailPage(item)} />
        </div>
      ))}
    </div>
  );
};
